import client from "./client";

export interface Answer {
  id: number;
  questionId: number;
  text: string;
  /** PagePreset id: 'heading' | 'body' | 'balanced'. Backed by `answers.preset`. */
  preset: string;
  /** Optional rewrite of the question text by the user. Sentinel '-' means
   *  "hide question on the page". Empty string = use original question. */
  clientQuestion: string;
  /** Буквица — первая буква ответа в книге декоративной картинкой. */
  dropCap: boolean;
  /** Number of pages this answer occupies in the generated book (≥1). Null until the first save. */
  pageCount: number | null;
  questionText: string;
  createdAt: string;
  updatedAt: string;
}

export const answersApi = {
  getByTemplate: (templateId: number) =>
    client.get<Answer[]>(`/answers/${templateId}`),

  upsert: (
    questionId: number,
    text: string,
    preset?: string,
    clientQuestion?: string,
    dropCap?: boolean,
  ) =>
    client.post<Answer>("/answers", { questionId, text, preset, clientQuestion, dropCap }),
};
